import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";

export const Route = createFileRoute("/")({
  head: () => routeHead('AGAPE — Scale SMEs with AI & Automation, No New Hires', META_DESCRIPTIONS.home.en, '/'),
  component: Index,
});
